const DESTROY_DATA_POINT = 'DESTROY_DATA_POINT';
const UPDATE_DATA_POINT = 'UPDATE_DATA_POINT';
const CREATE_DATA_POINT = 'CREATE_DATA_POINT';

export {
  DESTROY_DATA_POINT,
  UPDATE_DATA_POINT,
  CREATE_DATA_POINT,
};
